<div class="flex-direction-column gap-8 padding-15px">
  <span class="weight-600 font-14" style="margin-bottom: 11px">Adicionar Rotina ao Perfil</span>

  <app-select-multiple [listaInput]="rotinas" [itensSelecionado]="rotinasAssociadas" heightFormField="30px" campo="nome"
                       (selecionarItem)="rotinasAssociadas = $event; alteracaoService.camposAlterado()" colorLabel="black" label="Rotinas"></app-select-multiple>

  <div class="flex-direction-column justify-center gap-5">
    <app-button-padrao label="Salvar" backgroundColor="var(--verde-padrao)" fontWeight="600" width="100%" (buttonClick)="salvar()"></app-button-padrao>

    <app-button-padrao label="Cancelar" color="#BD1D00" backgroundColor="white" borderColor="#BD1D00" borderStyle="solid"
                       borderWidth="2px" fontWeight="600" width="100%" (buttonClick)="cancelar()"></app-button-padrao>
  </div>
</div>
